import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { messageAdmins } from '@wix/da-shared-react/pkg/redux/groups/actions';
import { Props } from './FeedNotice';
import { AppState } from '../../../types/store';
import { getThisGroup } from '../../../selectors/page';
import { getIsCurrentStreamEmpty } from '../../../selectors/stream';

export type StateProps = Pick<Props, 'thisGroup' | 'isFeedEmpty'>;
export type DispatchProps = Pick<Props, 'messageAdmins'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  thisGroup: getThisGroup(state),
  isFeedEmpty: getIsCurrentStreamEmpty(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  messageAdmins: messageAdmins,
};

export default connect(mapStateToProps, mapDispatchToProps);
